import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from '../services/muvika';
import messageStore from './message';
import playerStore from './player';
import performanceStore from './performance';
import { subscribeWithSelector } from 'zustand/middleware';
import TR from './../Trans';

const initialState = {
  isGettingSettings: false,
  isSet: false,
  settings: null,
  isSaveable: false,
  isWaiting: false
};

const settingsStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  clearSettings: () => {
    set({ settings: null });
  },
  setSaveable: (isSaveable) => {
    set({ isSaveable: isSaveable });
  },
  getSettings: (sessionToken) => {
    if (!get().isGettingSettings) {
      set({ isGettingSettings: true });
      MuvikaService.getSettings(sessionToken)
        .then(function (res) {
          if (res.data.error) {
            set({ isSet: false, isGettingSettings: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let settings = res.data.data;
            set({ isSet: true, settings: settings, isGettingSettings: false });
            console.log("currentVersion", settings.voc_enabled ? "vocal" : "normal");
            playerStore.setState({ currentVersion: settings.voc_enabled ? "vocal" : "normal" });
          }
        })
        .catch(function () { set({ isGettingSettings: false }); });
    }
  },
  setSettings: (sessionToken, settings, showSavedMessage = true, triggersWaiting=false) => {
    if(triggersWaiting){
      set({isWaiting: true})
    }
    MuvikaService.setSettings(sessionToken, settings)
      .then(function (res) {
        if (res.data.error) {
          set({ isSaveable: true, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          if (settings.sb_code === "random") {
            get().getSettings(sessionToken);
          } else {
            set({ isSet: true, settings: { ...settings } });
            /*let oldSettings = get().settings;
            if(oldSettings){
              if(!oldSettings.autoplay_enabled && settings.autoplay_enabled){
                let currentPerformance = performanceStore.getState().currentPerformance;
                performanceStore.setState({currentPerformance: {...currentPerformance}});
              }
            }*/
            if (showSavedMessage) {
              messageStore.getState().setMessage(sessionToken, TR.cm_saved);
            }
          }
          set({isWaiting: false})
        }
      })
      .catch(function () { set({isWaiting: false}) });
  },
})));

export default settingsStore;